export const movies = [
  {
    id: "xinghai-mihang",
    title: "星海迷航",
    type: "movie",
    year: 2024,
    genres: ["科幻", "冒险"],
    region: "中国大陆",
    duration: "128 分钟",
    rating: 8.7,
    director: "陆知远",
    castList: ["陈砚舟", "林晚星", "周牧云"],
    synopsis:
      "一支深空补给船队在返航途中偏离既定航线，船长老周发现导航系统被人为篡改。随着氧气与燃料逼近极限，六名船员必须在真相与生存之间做出抉择。影片以冷峻的太空质感包裹一段关于信任与牺牲的旅程，将孤独、恐惧与希望交织在同一片星海之中。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20art%2C%20lone%20astronaut%20silhouette%20facing%20a%20vast%20deep%20navy%20nebula%2C%20dramatic%20amber%20rim%20light%2C%20simple%20minimal%20dark%20background%2C%20high%20detail%20vertical%20composition%2C%20moody%20professional%20film%20artwork%2C%20no%20text&width=500&height=750&seq=star-mh-01&orientation=portrait",
    hotness: 96,
    updatedAt: "2024-11-18",
    featured: true,
  },
  {
    id: "changye-jiangming",
    title: "长夜将明",
    type: "movie",
    year: 2023,
    genres: ["悬疑", "剧情"],
    region: "中国大陆",
    duration: "112 分钟",
    rating: 8.2,
    director: "苏望",
    castList: ["韩向文", "秦语柔", "赵承宇"],
    synopsis:
      "一名退休刑警在整理旧卷宗时，发现一起沉寂十五年的悬案与当下的连环事件存在微妙关联。他在夜色中独自追踪线索，一步步走近被时间掩埋的真相。影片节奏克制，用光影与静默营造出层层递进的压迫感。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20crime%20thriller%20movie%20poster%20art%2C%20rainy%20night%20city%20alley%20with%20a%20solitary%20figure%20under%20warm%20amber%20street%20lamp%2C%20deep%20navy%20shadows%2C%20minimal%20moody%20background%2C%20vertical%20high%20detail%20film%20artwork%2C%20no%20text&width=500&height=750&seq=night-02&orientation=portrait",
    hotness: 88,
    updatedAt: "2024-09-30",
    featured: true,
  },
  {
    id: "shanhai-shiguang",
    title: "山海拾光",
    type: "movie",
    year: 2025,
    genres: ["奇幻", "冒险"],
    region: "中国大陆",
    duration: "141 分钟",
    rating: 9.0,
    director: "云墨白",
    castList: ["沈星河", "叶清歌", "顾长风"],
    synopsis:
      "少年偶然拾得一枚会发光的古老贝壳，从此听得见山川与海洋的低语。为寻找失落的故乡，他与神秘的摆渡人一同穿越传说中沉睡的海域。影片以瑰丽的想象构建东方奇幻世界，画面如流动的水墨长卷。",
    poster:
      "https://readdy.ai/api/search-image?query=Oriental%20fantasy%20movie%20poster%20art%2C%20glowing%20ancient%20shell%20floating%20above%20ink-wash%20mountains%20and%20misty%20sea%2C%20deep%20blue%20and%20amber%20gold%20palette%2C%20minimal%20background%2C%20vertical%20high%20detail%20film%20artwork%2C%20no%20text&width=500&height=750&seq=shanhai-03&orientation=portrait",
    hotness: 99,
    updatedAt: "2025-02-14",
    featured: true,
  },
  {
    id: "dushi-weiguang",
    title: "都市微光",
    type: "movie",
    year: 2024,
    genres: ["爱情", "剧情"],
    region: "中国大陆",
    duration: "106 分钟",
    rating: 7.6,
    director: "郑微微",
    castList: ["许安然", "蒋一诺", "孟知秋"],
    synopsis:
      "两个在深夜便利店偶遇的陌生人，用整整一年的时间慢慢交换彼此的秘密。在城市巨大的霓虹与喧嚣之下，他们学会在平凡日子里寻找微小而确凿的光。影片温柔细腻，献给每一个独自生活的人。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20drama%20movie%20poster%20art%2C%20two%20silhouettes%20standing%20close%20in%20a%20glowing%20late-night%20convenience%20store%2C%20warm%20amber%20bokeh%20and%20deep%20navy%20tone%2C%20minimal%20background%2C%20vertical%20cinematic%20film%20artwork%2C%20no%20text&width=500&height=750&seq=urban-04&orientation=portrait",
    hotness: 74,
    updatedAt: "2024-08-08",
    featured: false,
  },
  {
    id: "nifeng-xingdong",
    title: "逆锋行动",
    type: "movie",
    year: 2023,
    genres: ["动作", "悬疑"],
    region: "中国香港",
    duration: "119 分钟",
    rating: 8.1,
    director: "龙飞",
    castList: ["何震", "邓芷晴", "雷子豪"],
    synopsis:
      "潜伏多年的卧底警官在最后一次任务中身份暴露，必须在七十二小时内完成自我救赎。追车、爆破与近身格斗层层推进，影片在凌厉的动作场面里埋下关于忠诚与选择的追问。",
    poster:
      "https://readdy.ai/api/search-image?query=Action%20thriller%20movie%20poster%20art%2C%20running%20figure%20with%20dramatic%20backlight%20and%20flying%20sparks%2C%20deep%20navy%20and%20hot%20amber%20contrast%2C%20minimal%20dark%20background%2C%20vertical%20high%20detail%20film%20artwork%2C%20no%20text&width=500&height=750&seq=action-05&orientation=portrait",
    hotness: 84,
    updatedAt: "2023-12-22",
    featured: false,
  },
  {
    id: "chenshi-yanhuo",
    title: "尘世烟火",
    type: "movie",
    year: 2022,
    genres: ["剧情", "家庭"],
    region: "中国大陆",
    duration: "124 分钟",
    rating: 8.4,
    director: "方寸",
    castList: ["李敬川", "王秀兰", "孙小满"],
    synopsis:
      "一家开了三十年的老面馆即将拆迁，老板夫妇与远归的女儿在最后的营业日子里重新面对彼此。影片以一日三餐的烟火气串起一段被时代轻轻推着走的家庭记忆。",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20family%20drama%20movie%20poster%20art%2C%20steaming%20noodle%20bowl%20on%20an%20old%20wooden%20table%20at%20dusk%2C%20amber%20lantern%20glow%20and%20muted%20navy%20tones%2C%20simple%20background%2C%20vertical%20cinematic%20artwork%2C%20no%20text&width=500&height=750&seq=life-06&orientation=portrait",
    hotness: 70,
    updatedAt: "2023-03-11",
    featured: false,
  },
  {
    id: "shiguang-xinxiang",
    title: "时光信箱",
    type: "movie",
    year: 2024,
    genres: ["爱情", "奇幻"],
    region: "中国大陆",
    duration: "110 分钟",
    rating: 7.9,
    director: "温言",
    castList: ["江屿", "顾晓禾", "林家树"],
    synopsis:
      "小镇邮筒每到深夜便能寄出一封通往过去的信。女主角在一次次投递中试图改写遗憾，却发现每改变一件事，都会让另一段记忆悄然褪色。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20fantasy%20movie%20poster%20art%2C%20glowing%20vintage%20mailbox%20with%20drifting%20letters%20in%20starlight%2C%20deep%20navy%20night%20sky%20and%20warm%20amber%20glow%2C%20minimal%20background%2C%20vertical%20cinematic%20artwork%2C%20no%20text&width=500&height=750&seq=letter-07&orientation=portrait",
    hotness: 78,
    updatedAt: "2024-06-20",
    featured: false,
  },
  {
    id: "huangye-duxing",
    title: "荒野独行",
    type: "movie",
    year: 2023,
    genres: ["冒险", "悬疑"],
    region: "美国",
    duration: "133 分钟",
    rating: 8.0,
    director: "Ethan Cole",
    castList: ["Marcus Reed", "Lena Ford", "Owen Hart"],
    synopsis:
      "一名地质勘探员在无人区失联，唯一的线索是他留下的半本日志。救援队沿着日志里断断续续的记述深入峡谷，却发现真相远比失踪更复杂。",
    poster:
      "https://readdy.ai/api/search-image?query=Adventure%20thriller%20movie%20poster%20art%2C%20lone%20hiker%20silhouette%20on%20a%20canyon%20ridge%20at%20sunset%2C%20deep%20navy%20cliffs%20with%20amber%20sun%20rays%2C%20minimal%20background%2C%20vertical%20high%20detail%20film%20artwork%2C%20no%20text&width=500&height=750&seq=wild-08&orientation=portrait",
    hotness: 76,
    updatedAt: "2023-10-05",
    featured: false,
  },
  {
    id: "huanjing-bianyuan",
    title: "幻境边缘",
    type: "movie",
    year: 2025,
    genres: ["科幻", "悬疑"],
    region: "日本",
    duration: "118 分钟",
    rating: 8.6,
    director: "白石彻",
    castList: ["佐藤圭", "中村遥", "小林真"],
    synopsis:
      "一款号称能记录梦境的全新设备悄然流行，使用者却开始分不清现实与幻觉。脑科学研究者逐步揭开隐藏在数据背后的秘密实验。",
    poster:
      "https://readdy.ai/api/search-image?query=Cyberpunk%20sci-fi%20movie%20poster%20art%2C%20shattered%20glowing%20holographic%20face%20fragmenting%20into%20particles%2C%20deep%20navy%20and%20amber%20neon%2C%20minimal%20dark%20background%2C%20vertical%20cinematic%20artwork%2C%20no%20text&width=500&height=750&seq=dream-09&orientation=portrait",
    hotness: 92,
    updatedAt: "2025-01-09",
    featured: true,
  },
  {
    id: "wuming-zhizhong",
    title: "无名之辈",
    type: "movie",
    year: 2022,
    genres: ["喜剧", "剧情"],
    region: "中国大陆",
    duration: "101 分钟",
    rating: 7.8,
    director: "郝仁",
    castList: ["佟大川", "史小美", "范大力"],
    synopsis:
      "一个落魄的快递员、一位倔强的广场舞大妈和一名实习记者，因为一只走失的宠物被卷进了一场啼笑皆非的乌龙事件。",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20comedy%20drama%20movie%20poster%20art%2C%20quirky%20colorful%20city%20street%20scene%20at%20golden%20hour%2C%20amber%20and%20navy%20palette%2C%20simple%20clean%20background%2C%20vertical%20cinematic%20artwork%2C%20no%20text&width=500&height=750&seq=comedy-10&orientation=portrait",
    hotness: 68,
    updatedAt: "2022-12-01",
    featured: false,
  },
  {
    id: "guitu-lieche",
    title: "归途列车",
    type: "movie",
    year: 2024,
    genres: ["剧情"],
    region: "英国",
    duration: "115 分钟",
    rating: 8.3,
    director: "Sophie Blake",
    castList: ["Daniel Moore", "Grace Hale", "Tom Ellis"],
    synopsis:
      "一列因暴雪滞留的夜班列车里，八位素不相识的乘客被迫共度一夜。随着交谈展开，每个人藏在行李与沉默背后的故事逐渐浮现。",
    poster:
      "https://readdy.ai/api/search-image?query=Atmospheric%20drama%20movie%20poster%20art%2C%20vintage%20night%20train%20window%20with%20warm%20interior%20light%20and%20falling%20snow%2C%20deep%20navy%20and%20amber%20palette%2C%20minimal%20background%2C%20vertical%20cinematic%20artwork%2C%20no%20text&width=500&height=750&seq=train-11&orientation=portrait",
    hotness: 72,
    updatedAt: "2024-04-16",
    featured: false,
  },
  {
    id: "changan-milu",
    title: "长安秘录",
    type: "tv",
    year: 2024,
    genres: ["历史", "悬疑"],
    region: "中国大陆",
    duration: "全 40 集",
    rating: 8.8,
    director: "裴行简",
    castList: ["萧景行", "沈书瑶", "陆明烛"],
    synopsis:
      "盛唐长安城中，大理寺少卿与神秘女仵作联手侦破一连串离奇案件，每桩疑案背后都牵动着朝堂与市井的隐秘脉络。",
    poster:
      "https://readdy.ai/api/search-image?query=Historical%20mystery%20tv%20series%20poster%20art%2C%20ancient%20Chinese%20city%20lanterns%20at%20night%20with%20a%20cloaked%20figure%2C%20deep%20navy%20and%20warm%20amber%20glow%2C%20minimal%20background%2C%20vertical%20cinematic%20artwork%2C%20no%20text&width=500&height=750&seq=changan-12&orientation=portrait",
    hotness: 95,
    updatedAt: "2024-12-06",
    featured: true,
  },
  {
    id: "yizhe-renxin",
    title: "医者仁心",
    type: "tv",
    year: 2023,
    genres: ["医疗", "剧情"],
    region: "中国大陆",
    duration: "全 36 集",
    rating: 8.5,
    director: "许怀安",
    castList: ["宋嘉禾", "程野", "白露"],
    synopsis:
      "一群年轻医生在急诊科的日与夜里成长，他们在生死之间学习技术，也学习如何面对遗憾。每集一个病患故事，串联起医护群体的真实群像。",
    poster:
      "https://readdy.ai/api/search-image?query=Medical%20drama%20tv%20series%20poster%20art%2C%20doctor%20silhouette%20before%20a%20glowing%20hospital%20corridor%20at%20night%2C%20deep%20navy%20and%20clean%20amber%20light%2C%20minimal%20background%2C%20vertical%20cinematic%20artwork%2C%20no%20text&width=500&height=750&seq=doctor-13&orientation=portrait",
    hotness: 80,
    updatedAt: "2023-11-20",
    featured: false,
  },
  {
    id: "qingchun-jishi",
    title: "青春纪事",
    type: "tv",
    year: 2024,
    genres: ["青春", "爱情"],
    region: "中国大陆",
    duration: "全 30 集",
    rating: 7.9,
    director: "夏未央",
    castList: ["苏念", "许星言", "陈亦航"],
    synopsis:
      "高三那年的教室、天台与自行车棚，记录着一群少年少女笨拙又滚烫的喜欢。多年后重逢，他们终于有勇气说出当年没说出口的话。",
    poster:
      "https://readdy.ai/api/search-image?query=Youth%20romance%20tv%20series%20poster%20art%2C%20two%20students%20on%20a%20school%20rooftop%20under%20golden%20sunset%20sky%2C%20soft%20amber%20and%20navy%20palette%2C%20simple%20clean%20background%2C%20vertical%20cinematic%20artwork%2C%20no%20text&width=500&height=750&seq=youth-14&orientation=portrait",
    hotness: 82,
    updatedAt: "2024-07-12",
    featured: false,
  },
  {
    id: "poxiao-zhuixiong",
    title: "破晓追凶",
    type: "tv",
    year: 2025,
    genres: ["悬疑", "剧情"],
    region: "韩国",
    duration: "全 16 集",
    rating: 8.9,
    director: "金度勋",
    castList: ["崔敏俊", "李秀妍", "朴正宇"],
    synopsis:
      "重案组组长与犯罪心理侧写师组成临时搭档，追查一名从不留下痕迹的连环案犯。每接近真相一步，他们自己内心的裂缝就被照得更亮。",
    poster:
      "https://readdy.ai/api/search-image?query=Korean%20crime%20thriller%20tv%20series%20poster%20art%2C%20detective%20silhouette%20in%20rainy%20neon%20city%20at%20dawn%2C%20deep%20navy%20and%20amber%20neon%20palette%2C%20minimal%20background%2C%20vertical%20cinematic%20artwork%2C%20no%20text&width=500&height=750&seq=dawn-15&orientation=portrait",
    hotness: 97,
    updatedAt: "2025-03-01",
    featured: true,
  },
  {
    id: "jiade-muyang",
    title: "家的模样",
    type: "tv",
    year: 2023,
    genres: ["家庭", "剧情"],
    region: "中国大陆",
    duration: "全 42 集",
    rating: 8.2,
    director: "周慕青",
    castList: ["刘慧兰", "张建国", "周小北"],
    synopsis:
      "三代同堂的老宅里，祖辈的坚持、父辈的妥协与年轻一代的远行交织在一起。一场关于老房子去留的讨论，重新定义了「家」的样子。",
    poster:
      "https://readdy.ai/api/search-image?query=Heartwarming%20family%20drama%20tv%20series%20poster%20art%2C%20old%20courtyard%20house%20with%20warm%20window%20light%20at%20dusk%2C%20amber%20glow%20and%20muted%20navy%20tones%2C%20simple%20background%2C%20vertical%20cinematic%20artwork%2C%20no%20text&width=500&height=750&seq=family-16&orientation=portrait",
    hotness: 74,
    updatedAt: "2023-09-14",
    featured: false,
  },
  {
    id: "jianghu-shike",
    title: "江湖食客",
    type: "tv",
    year: 2024,
    genres: ["历史", "喜剧"],
    region: "中国大陆",
    duration: "全 24 集",
    rating: 8.1,
    director: "汤有方",
    castList: ["崔小鱼", "花婶婶", "燕十三"],
    synopsis:
      "一间开在渡口的无名小馆，来来往往的都是江湖中人。老板娘用一碗面、一壶酒，化解了一个又一个刀光剑影里的恩怨。",
    poster:
      "https://readdy.ai/api/search-image?query=Playful%20historical%20comedy%20tv%20series%20poster%20art%2C%20cozy%20ancient%20Chinese%20riverside%20tavern%20glowing%20at%20night%2C%20warm%20amber%20lanterns%20and%20navy%20tones%2C%20minimal%20background%2C%20vertical%20cinematic%20artwork%2C%20no%20text&width=500&height=750&seq=tavern-17&orientation=portrait",
    hotness: 71,
    updatedAt: "2024-05-23",
    featured: false,
  },
  {
    id: "weilai-jiyuan",
    title: "未来纪元",
    type: "tv",
    year: 2025,
    genres: ["科幻"],
    region: "美国",
    duration: "全 20 集",
    rating: 8.7,
    director: "Nora Quinn",
    castList: ["Ethan Ward", "Mia Sinclair", "Leo Grant"],
    synopsis:
      "在高度自动化的未来都市，一名数据工程师发现城市的决策核心正悄然改写人类的选择。她与地下组织的伙伴一同寻找系统最初的漏洞。",
    poster:
      "https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20tv%20series%20poster%20art%2C%20glowing%20wireframe%20metropolis%20with%20a%20lone%20figure%20on%20a%20bridge%2C%20deep%20navy%20and%20amber%20neon%20palette%2C%20minimal%20background%2C%20vertical%20cinematic%20artwork%2C%20no%20text&width=500&height=750&seq=future-18&orientation=portrait",
    hotness: 90,
    updatedAt: "2025-02-28",
    featured: true,
  },
  {
    id: "wulin-fengyunlu",
    title: "武林风云录",
    type: "tv",
    year: 2023,
    genres: ["武侠", "动作"],
    region: "中国大陆",
    duration: "全 38 集",
    rating: 8.3,
    director: "狄冲霄",
    castList: ["南宫翊", "云汐", "独孤寒"],
    synopsis:
      "名门正派与江湖散人因一本失传剑谱陷入纷争，出身寒微的少年在恩怨漩涡中一步步走向属于自己的侠义之道。",
    poster:
      "https://readdy.ai/api/search-image?query=Wuxia%20martial%20arts%20tv%20series%20poster%20art%2C%20swordsman%20standing%20on%20a%20misty%20cliff%20with%20flowing%20robe%2C%20deep%20navy%20mountains%20and%20amber%20mist%2C%20minimal%20background%2C%20vertical%20cinematic%20artwork%2C%20no%20text&width=500&height=750&seq=wuxia-19&orientation=portrait",
    hotness: 79,
    updatedAt: "2023-08-30",
    featured: false,
  },
  {
    id: "resou-nvwang",
    title: "热搜女王",
    type: "tv",
    year: 2024,
    genres: ["喜剧", "都市"],
    region: "中国大陆",
    duration: "全 28 集",
    rating: 7.7,
    director: "钱多多",
    castList: ["苏菲", "高明", "安琪"],
    synopsis:
      "一位过气艺人阴差阳错成了娱乐公司的公关总监，从此每天在热搜、危机与真话之间左右横跳。轻喜剧的外壳下，藏着关于真诚与名声的思考。",
    poster:
      "https://readdy.ai/api/search-image?query=Stylish%20urban%20comedy%20tv%20series%20poster%20art%2C%20glamorous%20city%20skyline%20at%20night%20with%20a%20confident%20figure%2C%20deep%20navy%20and%20bold%20amber%20accent%2C%20minimal%20background%2C%20vertical%20cinematic%20artwork%2C%20no%20text&width=500&height=750&seq=pr-20&orientation=portrait",
    hotness: 73,
    updatedAt: "2024-10-10",
    featured: false,
  },
];

export const heroSlides = [
  {
    id: "shanhai-shiguang",
    title: "山海拾光",
    tagline: "东方奇幻 · 2025 年度巨制",
    intro:
      "一枚会发光的贝壳，一段跨越山海的归乡之旅。少年在山川与传说的低语中，寻找遗失的故乡。",
    backdrop:
      "https://readdy.ai/api/search-image?query=Epic%20oriental%20fantasy%20cinematic%20backdrop%2C%20misty%20ink-wash%20mountains%20above%20a%20glowing%20deep%20navy%20sea%20with%20drifting%20amber%20light%20particles%2C%20dramatic%20atmosphere%2C%20no%20people%2C%20no%20text%2C%20wide%20cinematic%20composition&width=1600&height=900&seq=hero-shanhai&orientation=landscape",
    genre: "奇幻",
    rating: 9.0,
  },
  {
    id: "poxiao-zhuixiong",
    title: "破晓追凶",
    tagline: "悬疑犯罪 · 每周更新",
    intro:
      "重案组与犯罪心理侧写师联手追凶，每接近真相一步，他们内心的裂缝就被照得更亮。",
    backdrop:
      "https://readdy.ai/api/search-image?query=Moody%20crime%20thriller%20cinematic%20backdrop%2C%20rainy%20neon%20city%20street%20at%20dawn%20with%20reflections%20and%20amber%20light%20streaks%20over%20deep%20navy%20shadows%2C%20dramatic%20atmosphere%2C%20no%20people%2C%20no%20text%2C%20wide%20cinematic%20composition&width=1600&height=900&seq=hero-dawn&orientation=landscape",
    genre: "悬疑",
    rating: 8.9,
  },
  {
    id: "xinghai-mihang",
    title: "星海迷航",
    tagline: "科幻冒险 · 口碑佳作",
    intro:
      "深空船队偏离航线，六名船员必须在真相与生存之间做出抉择。",
    backdrop:
      "https://readdy.ai/api/search-image?query=Vast%20deep%20space%20cinematic%20backdrop%2C%20glowing%20navy%20nebula%20with%20amber%20star%20clusters%20and%20a%20tiny%20lone%20spaceship%20trail%2C%20ethereal%20atmosphere%2C%20no%20people%2C%20no%20text%2C%20wide%20cinematic%20composition&width=1600&height=900&seq=hero-star&orientation=landscape",
    genre: "科幻",
    rating: 8.7,
  },
];

export const collections = [
  {
    id: "changan-topic",
    title: "盛唐悬案专题",
    subtitle: "6 部古装探案作品",
    desc: "从长安到江南，跟着神探们穿过迷雾，看一桩桩疑案如何抽丝剥茧。",
    image:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20night%20city%20with%20warm%20amber%20lanterns%20and%20deep%20navy%20rooftops%2C%20mysterious%20atmospheric%20mood%2C%20painterly%20editorial%20style%2C%20no%20people%2C%20no%20text&width=800&height=600&seq=col-changan&orientation=landscape",
    link: "/category?type=tv&genre=%E5%8E%86%E5%8F%B2",
  },
  {
    id: "scifi-topic",
    title: "硬核科幻精选",
    subtitle: "8 部未来想象之作",
    desc: "当科技越过边界，人类将如何自处？一次关于未来的深度漫游。",
    image:
      "https://readdy.ai/api/search-image?query=Futuristic%20glowing%20wireframe%20city%20skyline%20at%20night%20in%20deep%20navy%20and%20amber%20neon%2C%20clean%20editorial%20sci-fi%20style%2C%20no%20people%2C%20no%20text&width=800&height=600&seq=col-scifi&orientation=landscape",
    link: "/category?type=movie&genre=%E7%A7%91%E5%B9%BB",
  },
  {
    id: "healing-topic",
    title: "治愈系温情单元",
    subtitle: "12 部生活流佳片",
    desc: "不赶时间的故事最动人，在一个个平凡瞬间里重新找回温柔。",
    image:
      "https://readdy.ai/api/search-image?query=Cozy%20warm%20sunset%20street%20scene%20with%20amber%20light%20and%20soft%20navy%20shadows%2C%20gentle%20editorial%20illustration%20style%2C%20no%20people%2C%20no%20text&width=800&height=600&seq=col-heal&orientation=landscape",
    link: "/category?type=movie&genre=%E5%89%A7%E6%83%85",
  },
  {
    id: "action-topic",
    title: "高能动作专场",
    subtitle: "10 部肾上腺素之选",
    desc: "追车、格斗与爆破，一次看爽最凌厉的动作设计。",
    image:
      "https://readdy.ai/api/search-image?query=Bold%20action%20cinematic%20scene%20with%20flying%20sparks%20and%20dramatic%20amber%20backlight%20over%20deep%20navy%20darkness%2C%20high%20energy%20editorial%20style%2C%20no%20people%2C%20no%20text&width=800&height=600&seq=col-action&orientation=landscape",
    link: "/category?type=movie&genre=%E5%8A%A8%E4%BD%9C",
  },
];

export const categoryEntries = [
  {
    type: "movie",
    title: "电影",
    subtitle: "精选海量电影作品",
    desc: "科幻、悬疑、爱情、动作……按题材快速找到想看的电影。",
    count: 11,
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20reel%20and%20projector%20light%20beam%20in%20a%20deep%20navy%20dark%20theater%20with%20warm%20amber%20glow%2C%20elegant%20minimal%20editorial%20style%2C%20no%20people%2C%20no%20text&width=800&height=560&seq=cat-movie&orientation=landscape",
  },
  {
    type: "tv",
    title: "电视剧",
    subtitle: "口碑热播剧集聚合",
    desc: "历史、家庭、青春、医疗……追一部好剧，度过每个夜晚。",
    count: 9,
    image:
      "https://readdy.ai/api/search-image?query=Retro%20television%20set%20glowing%20in%20a%20cozy%20deep%20navy%20room%20with%20warm%20amber%20light%2C%20elegant%20minimal%20editorial%20style%2C%20no%20people%2C%20no%20text&width=800&height=560&seq=cat-tv&orientation=landscape",
  },
];

export const genres = [
  "动作", "爱情", "科幻", "悬疑", "喜剧", "剧情",
  "奇幻", "冒险", "历史", "武侠", "医疗", "青春", "家庭", "都市",
];

export const regions = ["中国大陆", "中国香港", "美国", "日本", "韩国", "英国"];

export const years = [2025, 2024, 2023, 2022];